import React from 'react';
import './styles.scss';

interface ProjectImageProps {
  src: string;
  alt: string;
  description?: string;
  width?: string;
}

export const ProjectImage: React.FC<ProjectImageProps> = ({ 
  src, 
  alt, 
  description, 
  width = '80%' 
}) => {
  return (
    <div className="project-image-container" style={{ width }}>
      <img 
        src={src} 
        alt={alt}
        className="img-fluid rounded shadow-sm mb-2" 
      />
      {description && (
        <div className="image-description">
          {description}
        </div>
      )}
    </div>
  );
};